export default __webpack_public_path__ + "images/2c0ff792fb4b0d9f1b93cbd347247cc7-sudoku-game.svg";